<div class="aa-input-general">
  <div class="text-general-title mb-2 text-(--color-segundo)">
    {{ 'quotation.titles.clientData' | translate }}
  </div>
  <form [formGroup]="customerFormGroup" class="flex flex-col gap-1">
    <div class="subtitle-content gap-1 flex flex-col">
      <mat-label class="text-(--comp-input-label-normal) px-4">{{
        'quotation.fieldNames.personType' | translate
      }}</mat-label>
      <mat-form-field appearance="outline" class="w-full input-mat-form-field">
        <mat-select
          placeholder="{{ 'quotation.fieldNames.personType' | translate }}"
          formControlName="personType"
          (selectionChange)="onChangePersonType($event)"
          (blur)="onSubmitCustomer()"
        >
          @for (personType of personTypes; track personType.id) {
            <mat-option [value]="personType.id">
              {{ personType.description }}
            </mat-option>
          }
        </mat-select>
        @if (customerFormGroup!.get('personType')!.hasError('required')) {
          <mat-error>{{ 'Campo requerido' }}</mat-error>
        }
      </mat-form-field>
    </div>

    <!-- RFC / TIN -->
    <div class="subtitle-content gap-1 flex flex-col">
        <mat-label class="text-(--comp-input-label-normal) px-4">{{
          'quotation.fieldNames.TIN' | translate
        }}</mat-label>
        <mat-form-field appearance="outline" class="w-full">
          <input
            placeholder="{{ 'quotation.fieldNames.TIN' | translate }}"
            matInput
            formControlName="TIN"
            autocomplete="off"
            (blur)="onSubmitCustomer()"
          />
          @if(customerFormGroup.get('TIN')?.hasError('pattern')) {
            <mat-error>{{ 'inputs.invalidFormat' | translate}}</mat-error>
          }
          @if (
            customerFormGroup.get('TIN')?.hasError('maxlength')
          ) {M
            <mat-error>
                    {{
                      'inputs.maxlength'
                        | translate: { requiredLength:  customerFormGroup.get('TIN')?.errors!['maxlength'].requiredLength }
                    }}
                  </mat-error>
          }
          @if (
            customerFormGroup.get('TIN')?.hasError('minlength')
          ) {
            <mat-error>{{ 'inputs.minlength' | translate: { requiredLength:  customerFormGroup.get('TIN')?.errors!['minlength'].requiredLength } }}</mat-error>
          }
        </mat-form-field>
      </div>

    <div class="subtitle-content gap-1 flex flex-col">
      <mat-label class="text-(--comp-input-label-normal) px-4">{{
        'quotation.fieldNames.nameOrCompanyName' | translate
      }}</mat-label>
      <mat-form-field appearance="outline" class="w-full">
        <input
          placeholder="{{ 'quotation.fieldNames.nameOrCompanyName' | translate }}"
          matInput
          formControlName="firstName"
          autocomplete="off"
          (blur)="onSubmitCustomer()"
        />
        @if (customerFormGroup!.get('firstName')!.hasError('required')) {
          <mat-error>{{ 'Campo requerido' }}</mat-error>
        }
      </mat-form-field>
    </div>
    @if (customerFormGroup!.get('personType')!.value !== 3) {
      <div class="subtitle-content gap-1 flex flex-col">
        <mat-label class="text-(--comp-input-label-normal) px-4">{{
          'quotation.fieldNames.lastName' | translate
        }}</mat-label>
        <mat-form-field appearance="outline" class="w-full">
          <input
            placeholder="{{ 'quotation.fieldNames.lastName' | translate }}"
            matInput
            formControlName="lastName"
            autocomplete="off"
            (blur)="onSubmitCustomer()"
          />
          @if (customerFormGroup!.get('lastName')!.hasError('required')) {
            <mat-error>{{ 'Campo requerido' }}</mat-error>
          }
        </mat-form-field>
      </div>

      <div class="subtitle-content gap-1 flex flex-col">
        <mat-label class="text-(--comp-input-label-normal) px-4">{{
          'quotation.fieldNames.secondLastName' | translate
        }}</mat-label>
        <mat-form-field appearance="outline" class="w-full">
          <input
            placeholder="{{ 'quotation.fieldNames.secondLastName' | translate }}"
            matInput
            formControlName="secondLastName"
            autocomplete="off"
            (blur)="onSubmitCustomer()"
          />
          @if (customerFormGroup!.get('secondLastName')!.hasError('required')) {
            <mat-error>{{ 'Campo requerido' }}</mat-error>
          }
        </mat-form-field>
      </div>
    }

    <div class="subtitle-content gap-1 flex flex-col">
      <mat-label class="text-(--comp-input-label-normal) px-4">{{
        'quotation.fieldNames.phoneNumber' | translate
      }}</mat-label>
      <mat-form-field appearance="outline" class="w-full">
        <input
          placeholder="{{ 'quotation.fieldNames.phoneNumber' | translate }}"
          matInput
          formControlName="phoneNumber"
          [mask]="'(000) 000-0000'"
          autocomplete="off"
          (blur)="onSubmitCustomer()"
        />
        @if (customerFormGroup!.get('phoneNumber')!.hasError('required')) {
          <mat-error>{{ 'Campo requerido' }}</mat-error>
        }
      </mat-form-field>
    </div>

    <div class="subtitle-content gap-1 flex flex-col">
      <mat-label class="text-(--comp-input-label-normal) px-4">{{
        'quotation.fieldNames.email' | translate
      }}</mat-label>
      <mat-form-field appearance="outline" class="w-full">
        <input
          placeholder="{{ 'quotation.fieldNames.email' | translate }}"
          matInput
          formControlName="email"
          autocomplete="off"
          (blur)="onSubmitCustomer()"
        />
        @if (customerFormGroup!.get('email')!.hasError('email')) {
          <mat-error>{{ 'Formato inválido' }}</mat-error>
        }

        @if (customerFormGroup!.get('email')!.hasError('required')) {
          <mat-error>{{ 'Campo requerido' }}</mat-error>
        }
      </mat-form-field>
    </div>
  </form>
</div>
